<template>
  <el-form ref="form" :model="modelValue" :rules="rules" :label-width="itemLabelWidth" :disabled="disabled" class="orion-form">
    <el-row :gutter="16">
      <slot></slot>
    </el-row>
  </el-form>
</template>

<script setup lang="ts">
import { provide, reactive, toRef, useTemplateRef } from 'vue'
import { ElForm, ElRow } from 'element-plus'
import { type FormProps, type FormExpose, formContextKey } from './Form'
import OrionError from '../../error/OrionError'
import { difference, isEmpty } from 'lodash-es'

defineOptions({ name: 'OForm', inheritAttrs: false })

const { rules, itemSpan = 6, itemLabelWidth = 'auto', disabled = false, modelValue } = defineProps<FormProps>()

const emit = defineEmits(['update:modelValue'])

const updateModelValue = (name: string, value: any) => {
  if (!Object.keys(modelValue).includes(name)) {
    throw new OrionError(`modelValue中不存在[${name}]`)
  }
  emit('update:modelValue', { ...modelValue, [name]: value })
}

const updateModelValueMulti = (data: Record<string, any>) => {
  const modelKeys = Object.keys(modelValue)
  const dataKeys = Object.keys(data)
  const diff = difference(dataKeys, modelKeys)
  if (!isEmpty(diff)) {
    throw new OrionError(`modelValue中不存在[${diff.join(',')}]`)
  }
  emit('update:modelValue', { ...modelValue, ...data })
}

const formRef = useTemplateRef('form')

const validate: FormExpose['validate'] = async () => {
  return await formRef.value!.validate()
}

defineExpose({
  validate,
})

provide(
  formContextKey,
  reactive({
    modelValue: toRef(() => modelValue),
    updateModelValue,
    updateModelValueMulti,
    rules: toRef(() => rules),
    itemSpan: toRef(() => itemSpan),
    disabled: toRef(() => disabled),
  })
)
</script>
